<template>
	<div
			:class="{
				'fill-height': fillContainer || fillHeight,
				'fill-width': fillContainer || fillWidth,
			}"
	>
		<div
				v-if="hasError"
				:class="{
					'fill-height': fillContainer || fillHeight,
					'fill-width': fillContainer || fillWidth,
				}"
				class="d-flex"
		>
			<v-card
					class="mx-auto"
					max-width="740"
					outlined
					rounded="xl"
			>
				<v-list-item three-line>
					<v-list-item-content>
						<v-list-item-title class="text-h5 mb-1 text-center">
							{{ $t("pages.common.oops") }}
						</v-list-item-title>
						<!-- eslint-disable vue/no-v-html -->
						<div
								v-for="error in errors"
								:key="error"
								v-html="error"
						/>
						<!--eslint-enable-->
					</v-list-item-content>
				</v-list-item>
				<v-card-actions v-if="hasReloadButton">
					<div class="text-center fill-width">
						<v-btn
								class="no-uppercase"
								outlined
								rounded
								text
								@click="reload()"
						>
							<v-icon left>
								mdi-reload
							</v-icon>
							{{ $t("pages.common.reload") }}
						</v-btn>
					</div>
				</v-card-actions>
			</v-card>
		</div>
		<template v-else>
			<slot />
		</template>
	</div>
</template>

<script>
export default {
  name: "ErrorComponent",
  props: {
    hasError: {
      type: Boolean,
      required: false,
      default: false,
    },
    errors: {
      type: Array,
      required: false,
      default: () => [],
    },
    reload: {
      type: Function,
      required: false,
      default: null,
    },
    fillContainer: {
      type: Boolean,
      required: false,
      default: false,
    },
    fillWidth: {
      type: Boolean,
      required: false,
      default: false,
    },
    fillHeight: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    hasReloadButton() {
      return typeof this.reload === "function";
    },
  },
};
</script>
